/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Imesh Jayalath
 * @Date 02/05/2024
 */

import { Container } from "@mui/material";
import React from "react";
import ContactForm from "../Components/ContactUs/ContactForm.js";
import { Helmet } from 'react-helmet';

export default function Contact() {
  return (
    <>
    <Helmet>
          <title>Contact Us - Adelaide - Housekeeping | Home Cleaning | Office Cleaning in Adelaide - Australia | Domestic house cleaning | Office cleaning | Garden cleaning | Y-DIY | offers</title>
          <link rel="canonical" href={`${process.env.prodUrl}/contact`} key="canonical" />
        </Helmet>
    <Container>
      <div style={{ marginTop: "2rem", marginBottom: "10px" }}>
        <ContactForm />
      </div>
    </Container>
    </>
  );
}
